import { render, staticRenderFns } from "./MissingPrincipalOwner.vue?vue&type=template&id=5f07b735"
import script from "./MissingPrincipalOwner.vue?vue&type=script&lang=js"
export * from "./MissingPrincipalOwner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports